// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#dropzone {\n  border: solid 1px #EAEAEA;\n  background-color: #FFFFFF;\n  \n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n}\n#dropzone:hover {\n  border: solid 1px #CACACA;\n  cursor: pointer;\n}\n#dropzone.active {\n  border: solid 1px #CACACA;\n  background-color: #EAEAEA;\n}", ""]);
// Exports
module.exports = exports;
